import React, { useContext, useEffect, useRef, useState } from 'react';
import styles from '../styles/main.module.scss';

import GlobalContext from '../_contexts/GlobalContext';
import Header from './Header';
import Footer from './footerComponent';
import { Popup, Stack, Image, TextField, PrimaryButton, Label } from '@fluentui/react';
import { popupStyles } from '../constants/constants';


export interface IInfoFormProps {
    apiUrl : string;
    setmessage: Function;
    seterror: Function;
}

const InfoForm: React.FunctionComponent<IInfoFormProps> = (props: IInfoFormProps) => {
    const [init, setinit] = useState<boolean>(true);
    const [naam, setnaam] = useState<string>("");
    const [email, setemail] = useState<string>("");
    const [vraag, setvraag] = useState<string>("");

    const { DevEnabled, DebugEnabled, Strings, UNDERCONSTRUCTION } = useContext(GlobalContext);

    useEffect(() => {
        setinit(false);
    }, []);

    let validated = false;
    if (vraag.length > 10) {
        if (naam.length >= 3) {
            if (email.length > 5) {
                if (email.toLowerCase().match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)) {
                    validated=true;                    
                }
            }
        }
    }

    function submit() {
        let formData = new FormData();
        formData.append("name", naam);
        formData.append("email", email);
        formData.append("question", vraag);

        fetch(`${props.apiUrl}/Question`, {
                method: "Put", 
                mode: "cors", 
                referrerPolicy: "origin-when-cross-origin",
                body: formData
            }).then((response) => response.json()).then((data) => {
                if (data.success) {
                    props.setmessage("Vraag toegevoegd. We nemen z.s.m. contact met u op.");
                } else {
                    props.seterror(data.error);
                }
            }).catch((ex) => {
                console.log(ex);
            });
    }

    return (
        <Stack style={{padding:10}}>
            <div style={{backgroundColor:'lightblue', padding: 5, borderRadius:5}}>
                <h2>Stel je vraag</h2>
            </div>
            <TextField required label='Naam' value={naam} style={{minWidth:370}} onChange={(e,v) => { setnaam(v); }} />
            <TextField required label='E-mail' type="EMail" value={email} onChange={(e,v) => { setemail(v); }} />
            
            <TextField required multiline rows={8} maxLength={1000} label='Vraag' value={vraag} onChange={(e,v) => { setvraag(v); }} />
            <Stack horizontalAlign='end'>
                <Label style={{fontSize:"x-small", color:vraag.length<11?"red":""}}>{vraag.length} - 1000</Label>
            </Stack>

            <Stack horizontalAlign='end'>
                <PrimaryButton disabled={!validated} text="Indienen" style={{margin:10}} onClick={submit}/>
            </Stack>
        </Stack>
    );
}

export default InfoForm;